var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'is-loading': _vm.state.isLoading,
    'open-modal': _vm.state.openModal
  },attrs:{"id":"app"}},[(!_vm.state.formCompleted)?_c('div',[_c('form-builder',{attrs:{"steps":_vm.steps,"callback":_vm.nextStep}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }